
export default function convertToDateTime(ts) {
    if (ts == 'undefined') {
        return 'unknown';
    }
    let date = new Date(ts);
    return date.toUTCString();
}